<template>
  <v-slide-y-transition group tag="div" class="loan-container container">
    <div v-if="ready" column key="main">
      <section>
        <h1 class="font--m-1 mb-2">
          우리동네 크라우드 펀딩은?
        </h1>
        <p class="font--m-5">
          번개입금과 중소벤처기업부 X 소상공인시장진흥공단이 함께 진행하는 크라우드 펀딩입니다.
        </p>
      </section>

      <section class="full background--accent white--text">
        <div class="px py-3">
          <p class="font--m-6">나의 한도</p>
          <GetOffer
            :loading.sync="componentGetOffer.loading"
            :offer.sync="componentGetOffer.offer"
            :options="componentGetOffer.options"
          >
            <v-fade-transition hide-on-leave group>
              <v-layout
                v-if="!componentGetOffer.offer || componentGetOffer.loading"
                column
                justify-center
                key="offer-loading"
              >
                <h1 class="font-size--28" style="margin-bottom: 14px">한도를 산출중 입니다...
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    size="14"
                    width="2"
                  ></v-progress-circular>
                </h1>
              </v-layout>
              <template v-else>
                <h1 class="font-size--28" key="offer-amount">{{ loanAmount | commaFormat }}원</h1>
              </template>
            </v-fade-transition>
          </GetOffer>
        </div>
      </section>
      <section>
        <Description />
      </section>
      <section class="pt-8 pb-10">
        <ApiButton
          color="#1baaf1"
          :classes="['font--m-3', 'text--white']"
          buttonText="신청하기"
          loadingText="신청중 입니다."
          :callFn="request"
          :disabled="requestLoading || !requestable"
        />
      </section>
    </div>
  </v-slide-y-transition>
</template>

<script>
import loansRequestApi from '@/api/now/loansRequestApi'
import LoanService from '@/service/loan/LoanService'
import { mapState } from 'vuex'

export default {
  components: {
    Description: () => import('@/components/woori-crowd/Description.vue'),
    GetOffer: () => import('@/components/woori-crowd/GetOffer.vue'),
    ApiButton: () => import('@/components/loans-request/ApiButton.vue')
  },
  data() {
    return {
      ready: false,
      requests: [],
      requestLoading: false,
      componentGetOffer: {
        loading: false,
        offer: null,
        options: {
          loanType: 'woori_crowd',
          repaymentPeriodInDays: 180,
        },
      },
    }
  },
  computed: {
    ...mapState('auth', ['profile']),
    loanAmount() {
      return (!this.componentGetOffer.loading && this.componentGetOffer.offer?.amount) || 0
    },
    requestable() {
      return this.form && !this.componentGetOffer.loading && this.loanAmount > 0
    },
    form() {
      if (!this.componentGetOffer.offer) {
        return null
      }

      const {
        commissionRate,
        repaymentRatio,
        interestRate,
        overdueInterestRate,
        amount,
        uuid: initOfferUuid,
        periodInDays: repaymentPeriodInDays,
        loanType: type,
      } = this.componentGetOffer.offer
      return {
        amount,
        type,
        interestRate,
        overdueInterestRate,
        repaymentRatio,
        commissionRate,
        repaymentPeriodInDays,
        initOfferUuid,
        // eslint-disable-next-line no-empty-pattern
        disbursements: [],
      }
    },
    getRouterRequest() {
      return this.requests?.find((r) => true)
    },
  },
  mounted() {
    this.ready = true
  },
  watch: {
    getRouterRequest: {
      deep: true,
      async handler(v) {
        if (!v) {
          return
        }
        if (['false', false].includes(this.$route.query.autoRedirect)) {
          return
        }
        await this.movePage()
      },
    },
  },
  async created() {
    this.$store.commit('ui/headerTitle', '우리동네크라우드펀딩')
    await this.getRequests()
  },
  methods: {
    async getRequests() {
      const { data } = await loansRequestApi.getLoansRequests({ page: 1, size: 1000, type: 'woori_crowd' })
      this.requests = data.data
    },
    async request() {
      try {
        this.requestLoading = true
        let result = await LoanService.evaluation({ ignoreCertificate: true })
        if (result) {
          if (this.profile.is_loanable !== true) {
            await this.$swal.basic.alert({
              html: '대출신청을 할 수 없습니다. 고객센터로 문의 주세요.',
            })
            return
          }

          const { data } = await loansRequestApi.postLoansRequest(this.form)
          this.requests = [data, ...this.requests]
          await this.movePage()
        }
      } finally {
        this.requestLoading = false
      }
    },
    async movePage() {
      const request = this.requests[0]
      await this.$router.replace(`/woori-crowd/${request.uuid}`)
    },
  }
}
</script>
